module.exports = __webpack_public_path__ + "static/media/PHCT01.191e87f2.jpg";